import { AccountModel } from 'data-ng-authentication';
import { HostingService } from '../../services/hosting_service';
import { MicroRoutes } from '../../services/micro_routes';

interface IWindowSGDDesktop extends Window {
  hiReady: (callback: () => void) => void;
  $ip: {
    require<M>(s: string): Promise<M>;
    requires<M>(s: string[]): Promise<M[]>;
  };
}

declare const window: IWindowSGDDesktop;

export class NavCalendarController {
  constructor(public accountModel: AccountModel, public NetworkUrlConfiguration: any, public appConfigModel: any) {}
}

export const NavCalendarDirective = {
  restrict: 'E',
  replace: false,
  // we want to pollute the scope to save the micro and shut it down on element.destroy
  //
  scope: true,
  controller: 'NavCalendarController',
  link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: unknown, controller: NavCalendarController) {
    const calendarMicroEl = element[0];
    const { NetworkUrlConfiguration, accountModel } = controller;

    const hasUserLoggedIn = accountModel.id > 0;
    if (!hasUserLoggedIn) {
      return;
    }

    window.$ip
      .requires([
        './64b49d3c3fffee0b/micros/nav/calendar/bin/index.js?resource_type=module',
        './64b49d3c3fffee0b/micros/nav/calendar/bin/index.css'
      ])
      .then(([microDelegate]: [any]) => {
        // we will need this soon when we connect to STC
        // const stcURI = appConfigModel.model['core-campus_url'];
        const sgdURI = NetworkUrlConfiguration.configure().prependUrl;
        const account = {
          user_mode: 'student'
        };

        scope.microDelegate = microDelegate;

        return microDelegate.startup(calendarMicroEl, {
          routes: {
            uri: '/my/calendar'
          },
          view: {
            configuration: {
              account,
              endpoints: {
                host: {
                  application_name: 'sgd',
                  server: sgdURI
                },
                authorization: {
                  type: 'csrf'
                }
              }
            }
          }
        });
      });

    scope.$on('$destroy', () => {
      scope.microDelegate.shutdown();
    });
  }
};



// WEBPACK FOOTER //
// ./app/lib/host/components/nav-calendar/nav-calendar.ts